import moment from 'moment';
import { DATE_TIME_FORMAT } from '../../../../../ui-kitchen/src/constants/dateFormats';

export const diffDays = (day) => moment(day).diff(moment().startOf('day'), 'days');

export const getCancelEvent = (reservation, diffDaysFunc) => (
  {
    venue: reservation.venue.name,
    city: reservation.venue?.location?.city,
    'is event': !!(reservation?.event && reservation?.event?.name),
    event: (reservation?.event && reservation?.event?.name)
      ? reservation?.event?.name : undefined,
    'lead time': diffDaysFunc(reservation.day),
    ...(reservation.day && reservation.time && { time: moment(`${reservation.day} ${reservation.time}`).format(DATE_TIME_FORMAT) }),
    'party size': reservation.seats,
    'time is GDA': !!reservation?.isGda,
    'venue is GDA': reservation?.venue?.isGda,
    'pre-paid': !!(reservation?.payment?.invoice?.total !== 0),
    'cc required': !!(reservation?.cancellation?.fee?.amount !== 0
      || reservation?.payment?.invoice?.total !== 0
      || reservation?.venue?.allow_bypass_payment_method !== 1),
    'add-ons': reservation?.hasAddons,
  }
);

export const setToken = (conciergeToken, token) => (conciergeToken ? { concierge_resy_token: conciergeToken } : { resy_token: token });
